import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./Contact.css";

const GeneralForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    requirement: "",
    consent: false,
  });
  const [loading, setLoading] = useState(false); // Loader state

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
    
  //   setFormData({
  //     ...formData,
  //     [name]: type === "checkbox" ? checked : value,
  //   });
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    // Allow only numeric values for "phone" field
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader on form submit

    try {
      const response = await fetch("https://dasmesh-mailer.ritaz.in/general-send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // alert("Email sent successfully!");
        toast.success('Email sent successfully!'); // Success toast
        setFormData({}); // Reset form data
        resetForm(); // Call reset function after success
      } else {
        // alert("Error sending email!");
        toast.error('Error sending email!'); // Error toast
      }
    } catch (error) {
    //   alert("Error sending email!");
    toast.error('Error sending email!'); // Error toast
    } finally {
      setLoading(false); // Hide loader after submission
    }
  };

  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    address: "",
    requirement: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData); // Reset all fields to their initial state
  };

  return (
    <div className="contact-form-contact">
      <div>
        <h3>GENERAL ENQUIRY</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            required
          />
          <br />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email Address"
            required
          />
          <br />
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            required
            inputMode="numeric"
          />
          <br />
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Address"
          />
          <br />
          <textarea
            name="requirement"
            value={formData.requirement}
            onChange={handleChange}
            placeholder="Message"
          ></textarea>
          <br />
          <div className="contact-checkbox-form">
            <input
              type="checkbox"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
            />
            <p>
              By checking this box, you consent and agree to DASMESH sending
              text messages or placing voice calls (live or pre-recorded).
            </p>
          </div>

          {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Email"}
          </button>
        </form>
         {/* Toast container */}
         <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
            />
      </div>
    </div>
  );
};

export default GeneralForm;
